import { render, staticRenderFns } from "./SmsForm.vue?vue&type=template&id=1841dab4&scoped=true"
import script from "./SmsForm.vue?vue&type=script&lang=js"
export * from "./SmsForm.vue?vue&type=script&lang=js"
import style0 from "./SmsForm.vue?vue&type=style&index=0&id=1841dab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1841dab4",
  null
  
)

export default component.exports